import { render, staticRenderFns } from "./AiDetailViews.vue?vue&type=template&id=0acb7802&scoped=true&"
import script from "./AiDetailViews.vue?vue&type=script&lang=js&"
export * from "./AiDetailViews.vue?vue&type=script&lang=js&"
import style0 from "./AiDetailViews.vue?vue&type=style&index=0&id=0acb7802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb7802",
  null
  
)

export default component.exports